import { components, proxy } from '@/utils'

import { basic, core } from '@/components/g/input/mixins'

import render from './render'

export default {
  name: components['text-field'],

  mixins: [ core('input'), proxy(), basic() ],

  mounted() {
    this._setRequired()
    this._autoFocus()
  },

  render
}
